export default function isGramicci() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('gramicci') !== -1;
}
